if (typeof window !== 'undefined' && !window.__mkrTrackingInit_cmhd1gtfc0001vb0yeeofdn9z) {
  window.__mkrTrackingInit_cmhd1gtfc0001vb0yeeofdn9z = true;
  
(function() {
  // PostHog SDK stub — init is deferred until consent is confirmed.
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Ir Sr init jr $r Ci qr Hr Dr capture calculateEventProperties Wr register register_once register_for_session unregister unregister_for_session Qr getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync tn identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Jr Yr createPersonProfile setInternalOrTestUser Kr Pr nn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing zr debug ki Xr getPageViewId captureTraceFeedback captureTraceMetric Mr".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

  var _mkrPhToken = 'phc_qbDTSuJCBxyX8CACLOEhPNZBvJVcELuLXGG6J2ibUmK';
  var _mkrPhConfig = {
    api_host: 'https://athena.maker.co',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    name: 'ph_devi_cmhd1gtfc0001vb0yeeofdn9z',
    autocapture: { css_selector_allowlist: ['[data-tracking-id]'] },
    disable_surveys: true,
    capture_dead_clicks: false,
    loaded: function(posthog) {
      posthog.register({
        mkr_product: 'devi',
        mkr_project_id: 'cmhd1gtfc0001vb0yeeofdn9z',
        mkr_org_id: 'user_33tbl7B6e1bXN6KW4wjrevvqrth',
        mkr_organization_name: 'unknown',
        mkr_version: 1787731422996,
        mkr_host_domain: window.__mkr_host_domain || window.location.hostname,
        mkr_host_url: window.__mkr_host_url || window.location.href
      });
    },
  };

  var _mkrPhInited = false;
  var syncPostHogToConsent = function(allowed) {
    if (!allowed) {
      if (_mkrPhInited) posthog.opt_out_capturing();
      return;
    }
    if (_mkrPhInited) {
      posthog.opt_in_capturing();
    } else {
      _mkrPhInited = true;
      posthog.init(_mkrPhToken, _mkrPhConfig);
    }
  };

  // Only an explicit analytics === 'no' from the Shopify CMP denies.
  var readShopifyConsent = function() {
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return c.analytics !== 'no';
    } catch(e) { return true; }
  };
  var isConsentResolved = function() {
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return c.analytics === 'yes' || c.analytics === 'no';
    } catch(e) { return false; }
  };

  // Poll Shopify CMP every 100 ms; fail-open after 3 s (handles US stores with no banner).
  var startShopifyConsentPolling = function() {
    var start = Date.now(), resolved = false;
    var interval = setInterval(function() {
      if (resolved) return;
      if (!isConsentResolved() && Date.now() - start < 3000) return;
      clearInterval(interval);
      resolved = true;
      syncPostHogToConsent(readShopifyConsent());
    }, 100);
    document.addEventListener('visitorConsentCollected', function() {
      if (!resolved) { clearInterval(interval); resolved = true; }
      syncPostHogToConsent(readShopifyConsent());
    });
  };

  if (window.parent !== window) {
    // Iframe embed branch — consent signals forwarded by the parent loader via window vars
    // and postMessage. window.__mkr_shopify_cmp / __mkr_gpc / __mkr_accept_cookies are
    // injected into the srcdoc by iframe.ts before embed.js loads.
    if (window.__mkr_gpc) {
      // GPC forwarded from parent — deny, don't init.
    } else if (!window.__mkr_accept_cookies) {
      // Explicit acceptCookies=false forwarded from parent — deny.
    } else if (!window.__mkr_shopify_cmp) {
      // No Shopify CMP on the parent page — allow.
      syncPostHogToConsent(true);
    } else {
      // Shopify CMP detected on parent — default-deny, wait for consent postMessage.
      // Attach listener before posting ready so no message is missed.
      var _mkrIframeConsentReceived = false;
      var _mkrIframeFailOpen = setTimeout(function() {
        if (!_mkrIframeConsentReceived) {
          _mkrIframeConsentReceived = true;
          syncPostHogToConsent(true);
        }
      }, 3000);
      window.addEventListener('message', function(e) {
        if (!e.data || e.data.type !== 'mkr_tracking_consent') return;
        if (!_mkrIframeConsentReceived) {
          clearTimeout(_mkrIframeFailOpen);
          _mkrIframeConsentReceived = true;
        }
        syncPostHogToConsent(e.data.allowed);
      });
      // Tell the parent this listener is ready so it can flush any buffered consent.
      window.parent.postMessage({ type: 'mkr_iframe_consent_ready' }, '*');
    }
  } else {
    // Top-frame branch — simple and org embeds running directly on the customer's page.
    if (navigator.globalPrivacyControl === true) {
      // GPC: first-class deny signal, no init.
    } else if (window.acceptCookies === false) {
      // Explicit acceptCookies=false deny — checked before Shopify CMP so it always wins.
    } else if (!window.Shopify || typeof window.Shopify !== 'object') {
      // Non-Shopify site (or null window.Shopify): no explicit deny → allow.
      syncPostHogToConsent(true);
    } else {
      // Shopify store: auto-detect CMP, poll for consent, subscribe to runtime changes.
      startShopifyConsentPolling();
    }
  }
})();
  
}
import './index.css';
import React from "react";
import ReactDOM from "react-dom/client";
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById("cmhd1gtfc0001vb0yeeofdn9z-root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
